import queryKeys from '@/constants/queryKeys';
import { sendScreenerReminder } from '@/services/api/requests/notifications';
import { useMutation } from '@tanstack/react-query';
import useToast from '../useToast';
import { TCustomAxiosError } from '@/services/api';

const useSendScreenerReminder = (onSuccess?: () => void) => {
  const toast = useToast();

  const { mutate, data, isError, error, isPending } = useMutation({
    mutationKey: [queryKeys.notifications.sendScreenerReminder],
    mutationFn: async () => {
      const response = await sendScreenerReminder();

      return response;
    },
    onSuccess: () => {
      toast({
        status: 'success',
        title: 'Success',
        description: 'Screener Reminder sent successfully!',
      });

      onSuccess?.();
    },
    onError: (error: TCustomAxiosError) => {
      toast({
        title: 'Error while sending Screener Reminder',
      }, error);
    },
  });

  return { mutate, data, isError, error, isPending };
};

export default useSendScreenerReminder;
